export enum UnionMode {
    UNION_ALL = 'UNION ALL',
    UNION = 'UNION',
    INTERSECT = 'INTERSECT',
    EXCEPT = 'EXCEPT'
}

export enum UnionIcon {
    'UNION ALL' = 'union-all',
    'UNION' = 'union',
    'INTERSECT' = 'union-intersect',
    'EXCEPT' = 'union-except'
}
